import { render } from "./addSpecificsModal.vue?vue&type=template&id=bf8e5ad2&scoped=true"
import script from "./addSpecificsModal.vue?vue&type=script&lang=js"
export * from "./addSpecificsModal.vue?vue&type=script&lang=js"

import "./addSpecificsModal.vue?vue&type=style&index=0&id=bf8e5ad2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf8e5ad2"]])

export default __exports__